import { useCallback } from 'react'

import { useSelector } from 'react-redux'

import { makeSelectRole } from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { IS_PROD } from '@webapp/infrastructure/envs'
import { PermissionGroupNames } from '@webapp/models'
import { type IntercomFeedbackSurveyIdsEnum } from './IntercomFeedbackSurveyIdsEnum'

interface IUseIntercomShareFeedbackButtonPresenterProps {
  surveyId: IntercomFeedbackSurveyIdsEnum
}

export const useIntercomShareFeedbackButtonPresenter = ({
  surveyId,
}: IUseIntercomShareFeedbackButtonPresenterProps) => {
  const FT_4880_ENABLE_INTERCOM = useFeatureFlag('FT_4880_ENABLE_INTERCOM')
  const role = useSelector(makeSelectRole())

  const openIntercomFeedbackSurvey = useCallback(() => {
    window.Intercom('startSurvey', surveyId)
  }, [surveyId])

  return {
    states: {
      isIntercomEnabled:
        FT_4880_ENABLE_INTERCOM &&
        IS_PROD &&
        !!window?.Intercom &&
        PermissionGroupNames.SITE_ADMINISTRATOR !== role.name,
    },
    commands: {
      openIntercomFeedbackSurvey,
    },
  }
}
